'use client';

import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';

export default function NotFoundPage() {
  const { t } = useTranslation('errors');

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="text-8xl font-bold text-gray-200 dark:text-gray-700 select-none mb-4">
        404
      </div>
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
        {t('not_found.title', 'Seite nicht gefunden')}
      </h1>
      <p className="text-gray-500 dark:text-gray-400 mb-8 max-w-md">
        {t('not_found.description', 'Die aufgerufene Seite existiert nicht oder wurde verschoben.')}
      </p>
      <Link
        href="/dashboard"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors"
      >
        {t('not_found.back_home', 'Zur Startseite')}
      </Link>
    </div>
  );
}
